// extracted by mini-css-extract-plugin
var _1 = "aFSN3O2Qhh4FqjePRYT3";
var _2 = "aaRM_DpYs_hBjAzZpxKT";
var _3 = "qOQrvfHpzEjJUcg06NLp";
export { _1 as "button", _2 as "off", _3 as "on" }
